import lottie from 'lottie-web';

export default () => {
  const hero = document.querySelectorAll('.hero');

  hero.forEach((block) => {
    const videoWrappers = block.querySelectorAll('.hero__video-wrapper');
    const playButton = block.querySelector('.hero__btn');

    videoWrappers.forEach((videoWrapper) => {
      const animationContainer = videoWrapper.querySelector('.hero__animation');
      const video = videoWrapper.querySelector('.hero__video');
      const jsonUrl = animationContainer?.getAttribute('data-url');

      const animation = jsonUrl ? lottie.loadAnimation({
        container: animationContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: jsonUrl,
      }) : null;

      videoWrapper.addEventListener('sal:in', ({ detail }) => {
        video?.addEventListener('loadeddata', () => {
          if (video.readyState >= 2) {
            requestAnimationFrame(() => {
              if (animation) {
                animation.addEventListener('complete', () => {
                  video.classList.add('visible');
                  video.play();
                });
                animation.play();
              } else {
                video.classList.add('visible');
                video.play();
              }
            });
          }
        });
        video?.setAttribute('src', video?.getAttribute('data-src'));
      });

    });

    playButton?.addEventListener('click', (event) => {
      event.preventDefault();
    })
  });
};
